<template>
  <header  class="app-header-container">
      <b-row class="header-top">
        <b-container>
          <b-nav align="right">
          <b-nav-item-dropdown 
            size="sm"
            style="font-size: 14px;"
            class="test-dropdown mx-1 mt-1"
          >
            <template v-slot:text>
              {{'headerLocale' | localize}}
            </template>    
            <b-dropdown-item href="#" @click="localeRu" class="lang-menu-item">Ру</b-dropdown-item>
            <hr>
            <b-dropdown-item href="#" @click="localeUA" class="lang-menu-item">Укр</b-dropdown-item>
          </b-nav-item-dropdown>
          </b-nav>
        </b-container>
      </b-row>

    <b-navbar  
      toggleable="lg" 
      type="dark" 
      variant="info"
    >
      <b-container>
        <div class="image-container">        
          <b-navbar-brand class="logo-img">
            <a href="/"><img alt="logo" src="https://weltum.com/home/core_themes/item_1/logo/logo.svg"></a>
          </b-navbar-brand>
        </div>

        <b-navbar-toggle target="nav-collapse">
          <template>
            <div class="hamburger-inner"></div>
            <div class="hamburger-inner"></div>
            <div class="hamburger-inner"></div>
          </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <div class="mobile-lang-switcher d-xs-block d-sm-block d-md-none d-lg-none d-xl-none">
              <b-button variant="link" @click="localeRu" :class="{active: isRu}" v-b-toggle.nav-collapse >Ру</b-button>
              <span style="margin: 0 20px">|</span>
              <b-button variant="link" @click="localeUA" :class="{active: isUk}" v-b-toggle.nav-collapse >Укр</b-button>
            </div>
            <b-nav-item
              v-if="isAuth"
              :to ="{ name: 'Main' }"
              exact
            >
              {{'headerBills' | localize}}
            </b-nav-item>
            <b-nav-item 
              v-if="isAuth" 
              :to ="{ name: 'NewAddress' }" 
              exact
            >
              {{'headerAddUserAderss' | localize}}
            </b-nav-item>
            <b-nav-item
              v-if="isAuth" 
              :to ="{ name: 'UserProfile' }" 
              exact
            >
              {{'headerUserProfile' | localize}}
            </b-nav-item>
            <b-nav-item
              href="https://weltum.com/" 
              target="_blank"
            >
              {{'headerMainSite' | localize}}
            </b-nav-item>
            <b-nav-item 
              v-if="!isAuth"
              :to ="{ name: 'testRegistration' }"
              exact
            >
              {{'headerRegistration' | localize}}
            </b-nav-item>
            <b-nav-item
                :to="{ name: 'Faq'}"
                exact
            >
              {{ "headerQA" | localize}}
            </b-nav-item>
            <b-nav-item
              v-if="headerType" 
              :to ="{ name: 'UserAddress' }" 
              exact
            >
              {{'headerMain' | localize}}
            </b-nav-item>
            <b-nav-item 
              v-if="headerType" 
              :to ="{ name: 'UserAddress' }" 
              exact
            >
              {{'headerLogin' | localize}}
            </b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
            <b-nav-item 
              v-if="isAuth" 
              @click="logout"
            >
              {{'headerLogout' | localize}}
            </b-nav-item>
            <b-nav-item 
              v-if="!isAuth" 
              :to ="{ name: 'Login' }" 
              exact
            >
              {{'headerLogin' | localize}}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    
  </header>
</template>
<script>
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
    props: ['headerType'],
    computed: {
      ...mapGetters(['isAuth']),
      isUk(){
        return this.$store.state.locale === 'uk_UA'
      },
      isRu(){
        return this.$store.state.locale === 'ru_RU'
      },
    },
    async mounted() {
      await this.log()
      if(localStorage.weltumTimeAuth) {
        this.loginTime = +localStorage.weltumTimeAuth + +localStorage.weltumtokenTimeAlive
        if (+this.loginTime >= +Date.now()) {
          this.$store.commit('setAuth', true)
        }
      }
      if(localStorage.getItem("weltumLang") && localStorage.weltumLang === 'ru'){
        this.localeRu()
      }else{
        this.localeUA()
      }
    },
    methods:{
      // log(){
      //   if(! localStorage.getItem("weltumKey")){
      //   }
      // },
      localeRu(){
        this.$store.commit('localize', 'ru_RU')

        const HEADERS =  ['Период начисления', 'Остаток на начало месяца (долг - «+», переплата - «-»)', 'Начислено','Перерасчет','Абонплата','Оплачено','Монетизация','Остаток на конец месяца (долг - «+», переплата - «-»)']
        this.$store.commit('tableHeadersLang', HEADERS)

        const DATES =  ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        this.$store.commit('tableDatesLang', DATES)

        const NO_DATA_TEXT = "Сначала выберите диапазон дат"
        this.$store.commit('noDataCommit', NO_DATA_TEXT)
        localStorage.weltumLang = 'ru'
      },
      localeUA(){
        this.$store.commit('localize', 'uk_UA')

        const HEADERS =  ['Період розрахунку', 'Залишок на початок місяця («+» - борг, «-» - переплата)', 'Нараховано','Перерахунок','Абонплата','Сплачено','Монетизація', 'Залишок на кінець місяця («+» - борг, «-» - переплата)']
        this.$store.commit('tableHeadersLang', HEADERS)

        const DATES =  ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень']
        this.$store.commit('tableDatesLang', DATES)

        const NO_DATA_TEXT = "Спочатку визначте діапазон дат"
        this.$store.commit('noDataCommit', NO_DATA_TEXT)
        localStorage.weltumLang = 'uk'
      },
      async logout(){
        localStorage.removeItem("weltumLastUrl")
        this.$store.state.isAuth = 'undefined'
        await this.$store.dispatch('logout')
        if(this.$router.currentRoute.path !== `${config.ROUTE_PREFIX}/login`) this.$router.push( { path: `${config.ROUTE_PREFIX}/login` } )
      }
    }

}
</script>
<style scoped>
.lang-menu-item .dropdown-item {
  font-size: 16px;
  margin: auto;
  padding: initial;
}
</style>